import React from 'react';
import { FaAward } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import ME from '../../assets/kashmir.jpeg'
import './intro.css';

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>4+ years</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p>Adaptable Software Engineer with 4+ years of professional experience,
with a strong focus on modern web application development and
frontend engineering. Proficient in JavaScript, TypeScript, React.js, Next.js,
and Node.js, with hands-on experience building responsive, scalable,
and user-centric applications. Experienced in developing and
maintaining HR management solutions, working across modules such as
employee management, attendance, leave, payroll, overtime, and
offboarding. Strong understanding of modern UI development, API
integration, responsive design, performance optimization, and
troubleshooting complex application issues.
Previously contributed to the LSEG (London Stock Exchange Group)
project with Refinitiv at Tech Mahindra, developing and maintaining
production-critical systems on IBM Mainframe using PL/I, Assembler, and
JCL. Passionate about continuous learning and adapting to modern
technologies, with a strong interest in building reliable, maintainable,
and high-quality software solutions.
</p>
          <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default Intro